export enum EAppPlatform {
  Android = 1,
  iOS = 2,
  Windows = 3,
  Web = 4,
  Unknown = 99,
}

export const platformLabels: Record<number, string> = {
  [EAppPlatform.Android]: 'Android',
  [EAppPlatform.iOS]: 'iOS',
  [EAppPlatform.Windows]: 'Windows',
  [EAppPlatform.Web]: 'Web',
  [EAppPlatform.Unknown]: 'Desconhecido',
};

export const platformIcons: Record<number, string> = {
  [EAppPlatform.Android]: 'android',
  [EAppPlatform.iOS]: 'apple',
  [EAppPlatform.Windows]: 'brand-windows',
  [EAppPlatform.Web]: 'world',
  [EAppPlatform.Unknown]: 'help',
};
